import { render, staticRenderFns } from "./VisaHelpModal1.vue?vue&type=template&id=12563fcc&scoped=true"
import script from "./VisaHelpModal1.vue?vue&type=script&lang=js"
export * from "./VisaHelpModal1.vue?vue&type=script&lang=js"
import style0 from "./VisaHelpModal1.vue?vue&type=style&index=0&id=12563fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12563fcc",
  null
  
)

export default component.exports